import { CircleStackIcon } from "@heroicons/react/24/outline";

import { FreeSubscription } from "@/common/model/FreeSubscription";
import StatusBadge from "../shared/StatusBadge";
import GrantedBy from "./GrantedBy";
import ItemCard from "../shared/ItemCard";
import ActionButtons from "../shared/ActionButtons";
import { formatDateForDisplay } from "@/utils/dateUtils";

type FreeSubscriptionItemProps = {
  subscription: FreeSubscription;
  onEdit: (subscription: FreeSubscription) => void;
  onEndNow: (subscription: FreeSubscription) => void;
  onDelete: (subscription: FreeSubscription) => void;
};

export function FreeSubscriptionItem({
  subscription,
  onEdit,
  onEndNow,
  onDelete,
}: FreeSubscriptionItemProps) {
  const content = (
    <>
      <div className="grid lg:grid-cols-2 gap-4">
        <div>
          <p className="text-white90 font-semibold">{subscription.userName}</p>
          <p className="text-white75 text-sm">{subscription.userEmail}</p>
          <p className="text-gray-400 text-xs">{subscription.userId}</p>
        </div>
        <div className="lg:text-right">
          <p className="text-white90">
            Start: {formatDateForDisplay(subscription.startDate)}
          </p>
          <p className="text-white90">
            End: {formatDateForDisplay(subscription.endDate)}
          </p>
        </div>
      </div>
      <div className="my-4 text-white90 text-sm">
        Observations: {subscription.observations}
      </div>
      <div className="mt-4">
        <div className="flex justify-between">
          <GrantedBy name={subscription.grantedByUserName} />
          <StatusBadge status={subscription.status} />
        </div>
        {subscription.fromMigration && (
          <div className="w-full flex justify-center mt-6 lg:justify-start lg:mt-2">
            <span className="inline-flex items-center gap-x-1.5 rounded-full bg-purple-300 px-2 py-1 font-medium text-gray-700">
              <CircleStackIcon className="size-4 fill-gray-400" />
              <p className="w-full text-xs">From migration</p>
            </span>
          </div>
        )}
        {subscription.deletedAt && (
          <p className="text-red20 text-sm mt-4">
            Deleted at: {formatDateForDisplay(subscription.deletedAt)}
          </p>
        )}
      </div>
    </>
  );

  const footer = !subscription.deletedAt ? (
    <ActionButtons
      onEdit={() => onEdit(subscription)}
      onDelete={() => onDelete(subscription)}
      onEndNow={
        subscription.status === "active"
          ? () => onEndNow(subscription)
          : undefined
      }
      showEndNow={subscription.status === "active"}
    />
  ) : null;

  return <ItemCard content={content} footer={footer} />;
}
